import React, {useEffect, useState} from 'react';
import ReactFusioncharts from 'react-fusioncharts';
import {reportGeneratorsStore} from '../../stores/ReportGeneratorsStore';
import {createChartConfig} from '../../services/chartService';
import {observer} from 'mobx-react-lite';
import {KPI} from './Kpi';
import {SingleSeriesChartTypesOptions} from '../../chartConsts';
import {ChartConfig} from '../../types';
import {reportWebSdkService} from '../../services/reportWebSdkService';
import {CircularLoader} from '../../../../components/CircularLoader/CircularLoader';
import {noop} from '@priority-software/priority-style-react';
import {prepareInputsData} from './utils';

const Chart = observer(() => {
    const currentScreen = reportGeneratorsStore?.currentScreen;
    const {currentReport} = currentScreen;
    const [config, setConfig] = useState<ChartConfig>(null);
    const [isLoadingExplanatoryReport, setIsLoading] = useState<boolean>(false);

    const onDataPlotClick = async (config: ChartConfig) => {
        setIsLoading(true);
        const reportInputsMetaData = prepareInputsData(config);
        currentScreen.setExpReportInputsMetaData(reportInputsMetaData);
        await reportWebSdkService.startProc();
        setIsLoading(false);
    };

    const getChartInfo = async () => {
        const chartConfig = await currentScreen?.getChartConfig(currentReport?.reportId.toString());
        if (chartConfig) {
            chartConfig.data = currentScreen?.getChartData;
            setConfig(chartConfig);
        }
    };

    useEffect(() => {
        getChartInfo();
    }, [currentReport]);

    if (!config) {
        return null;
    }
    config.dataPlotEventHandler = config.explanatoryReport ? () => onDataPlotClick(config) : noop;
    if (config['type'] === SingleSeriesChartTypesOptions.kpi) {
        return <KPI config={config} />;
    } else {
        const finalConfig = createChartConfig(config);
        return (
            <>
                <ReactFusioncharts {...finalConfig} />
                {isLoadingExplanatoryReport && (
                    <div style={{position: 'absolute'}}>
                        <CircularLoader />
                    </div>
                )}
            </>
        );
    }
});

export default Chart;
